import { PARAM } from '@App/navigation/param'

const RELEASE_NOTES_ROUTE = 'release-notes'
const UPCOMING_NOTES_ROUTE = 'upcoming-notes'
export const ROYALTIES_ROUTE = 'royalties'
export const STATEMENTS_ROUTE = 'statements'
export const ANNUAL_STATEMENTS_ROUTE = 'annual-statements'
export const RATE_SHEETS_ROUTE = 'rate-sheets'
export const OVERCLAIM_ROUTE = 'overclaim'
export const OVERCLAIM_VIEW_ROUTE_WITH_OC_HEADER_ID = `${OVERCLAIM_ROUTE}/${PARAM.overclaimHeaderId}`
export const OVERCLAIM_UPLOAD_DOCUMENTS_ROUTE_WITH_OC_HEADER_ID = `${OVERCLAIM_VIEW_ROUTE_WITH_OC_HEADER_ID}/upload-documents`
const LOGIN_ROUTE = 'login'
const NOTIFICATION_PREFERENCES_ROUTE = 'notification/preferences'
export const VIEW_WORK_ROUTE = 'catalog/work'
export const VIEW_SUBMISSION_ROUTE = 'registration-history/submission'
export const VIEW_TRANSACTION_ROUTE = 'registration-history/transaction'
const PUBLIC_VIEW_WORK_ROUTE_WITH_WORK_ID = `catalog/work/${PARAM.workId}`
const CONTACT_US_ROUTE = 'contact-us'
export const VIEW_ROUTE = 'view'
export const VIEW_DRAFT_ROUTE = 'registration-drafts/draft'
export const RECORDING_ROUTE = 'recording'
export const RH_MAINTENANCE_ROUTE = 'maintenance'
export const RH_CONTACT_ROUTE = `${RH_MAINTENANCE_ROUTE}/contact`
export const RH_USER_PERMISSION_ROUTE = `${RH_MAINTENANCE_ROUTE}/user-permissions`
export const CATALOG_ROUTE = 'catalog'
export const CATALOG_TRANSFER_ROUTE = 'catalog-transfer'
export const CHANGE_REQUESTS_ROUTE = 'change-requests'
export const TRANSFER_ROUTE = 'transfer'
export const HISTORY_ROUTE = 'registration-history'
export const WORK_MERGE_ROUTE = 'work-merge'
export const DRAFTS_ROUTE = 'registration-drafts'
export const MATCH_HISTORY_ROUTE = 'match-history'
const INACTIVE_ROUTE = 'handle-inactive'
const SIGN_UP_ROUTE = 'sign-up'
export const KYC_ROUTE = 'verify-user'
const SIGN_UP_COMPLETE_ROUTE = 'sign-up-complete'
const FORGOT_PASSWORD_ROUTE = 'forgot-password'
export const CREATE_PASSWORD_ROUTE = 'create-password'
const NEW_USER_ROUTE = 'new-user'
const CREATE_PASSWORD_ROUTE_WITH_ACT_CODE = `${CREATE_PASSWORD_ROUTE}/${PARAM.activatingCode}`
const SEARCH_ROUTE = 'search'
const SEARCH_ROUTE_WITH_TAB_NAME = `${SEARCH_ROUTE}/${PARAM.tabName}`
const ACCESS_DENIED_ROUTE = 'access-denied'
const UI_ROUTE = 'ui'
const ENROLL_MFA_ROUTE = 'enroll-mfa'
export const RECORDING_DETAILS_ROUTE = 'recording-details'
const RECORDING_DETAILS_ROUTE_WITH_RECORDING_ID = `${RECORDING_DETAILS_ROUTE}/${PARAM.recordingId}`
const PROFILE_ROUTE = 'profile'
const CHANGE_PASSWORD_ROUTE = `${PROFILE_ROUTE}/change-password`
// register rightsholder routes
const REGISTRATION_MEMBER_ROUTE = 'registration-member'
const FORM_SEGMENT = 'form'
const QUESTIONNAIRE_ROUTE = 'questionnaire'
// register songwriter routes
const REGISTRATION_SONGWRITER_ROUTE = 'registration-songwriter'
export const RIGHTSHOLDER_ROUTE = 'member'
const RIGHTSHOLDER_ROUTE_WITH_ID = `${RIGHTSHOLDER_ROUTE}/${PARAM.rightsholderId}`
const BENEFITS_ROUTE = 'benefits'

const RIGHTSHOLDER_SUB_ROUTES = Object.freeze({
    summary: 'summary',
    dashboard: 'dashboard',
    benefits: BENEFITS_ROUTE,
    catalog: {
        viewWork: `${VIEW_WORK_ROUTE}/${PARAM.workId}/${VIEW_ROUTE}`,
        changeRequests: {
            root: `${CATALOG_ROUTE}/${CHANGE_REQUESTS_ROUTE}`,
            view: `${CATALOG_ROUTE}/${CHANGE_REQUESTS_ROUTE}/${PARAM.suggestionId}`,
        },
        root: CATALOG_ROUTE,
    },
    catalogTransfer: {
        root: CATALOG_TRANSFER_ROUTE,
        wizardLanding: `${CATALOG_TRANSFER_ROUTE}/${TRANSFER_ROUTE}`,
        wizard: `${CATALOG_TRANSFER_ROUTE}/${TRANSFER_ROUTE}/${PARAM.transferId}/wizard`,
        view: `${CATALOG_TRANSFER_ROUTE}/${TRANSFER_ROUTE}/${PARAM.transferId}/view`,
    },
    registrationHistory: {
        root: `${HISTORY_ROUTE}`,
        submission: `${VIEW_SUBMISSION_ROUTE}/${PARAM.workId}/${VIEW_ROUTE}`,
        transaction: `${VIEW_TRANSACTION_ROUTE}/${PARAM.workId}/${VIEW_ROUTE}`,
        resubmit: `${HISTORY_ROUTE}/resubmit`,
    },
    workMerge: {
        root: `${WORK_MERGE_ROUTE}`,
        newRequest: `${WORK_MERGE_ROUTE}/new`,
        reviewRequest: `${WORK_MERGE_ROUTE}/review/${PARAM.workMergeRequestId}`,
        request: `${WORK_MERGE_ROUTE}/${PARAM.workMergeRequestId}`,
    },
    drafts: {
        root: `${DRAFTS_ROUTE}`,
        viewDraft: `${VIEW_DRAFT_ROUTE}/${PARAM.workId}/${VIEW_ROUTE}`,
    },
    claimingTool: 'claiming-tool',
    matchingTool: 'matching-tool',
    matchHistory: {
        recording: `${MATCH_HISTORY_ROUTE}/${PARAM.submissionId}/${RECORDING_ROUTE}/${PARAM.recordingGroupCategory}`,
        submission: `${MATCH_HISTORY_ROUTE}/${PARAM.submissionId}`,
        root: MATCH_HISTORY_ROUTE,
    },
    overclaim: {
        root: OVERCLAIM_ROUTE,
        view: OVERCLAIM_VIEW_ROUTE_WITH_OC_HEADER_ID,
        uploadDocuments: OVERCLAIM_UPLOAD_DOCUMENTS_ROUTE_WITH_OC_HEADER_ID,
    },
    royalties: {
        statements: STATEMENTS_ROUTE,
        annualStatements: ANNUAL_STATEMENTS_ROUTE,
        rateSheets: RATE_SHEETS_ROUTE,
        root: ROYALTIES_ROUTE,
    },
    maintenance: {
        rightsholderContact: `${RH_CONTACT_ROUTE}/${PARAM.contactId}`,
        rightsholderContacts: `${RH_MAINTENANCE_ROUTE}/contacts`,
        userPermission: `${RH_USER_PERMISSION_ROUTE}/${PARAM.userId}`,
        userPermissions: RH_USER_PERMISSION_ROUTE,
        root: RH_MAINTENANCE_ROUTE,
    },
})
// work routes
const CREATE_WORK_ROUTE = 'create-work'
const MANUAL_ROUTE = 'manual'
const WIZARD_ROUTE = `${MANUAL_ROUTE}/wizard`
const FORM_ROUTE = `${MANUAL_ROUTE}/form`
const BULK_ROUTES = Object.freeze({
    root: 'bulk',
    fileUpload: 'file-upload',
    fileReview: 'file-review',
    submission: 'submission',
})
const EDIT_ROUTE = 'edit'
const EDIT_WORK_ROUTE = `${CATALOG_ROUTE}/${PARAM.typeWork}/${PARAM.workId}/${EDIT_ROUTE}`
const EDIT_DRAFT_ROUTE = `${DRAFTS_ROUTE}/${PARAM.typeWork}/${PARAM.workId}/${EDIT_ROUTE}`
// work step routes
const STEP_ROUTES = Object.freeze({
    workDetails: 'work-details',
    writers: 'writers',
    writersShares: 'writers-shares-role',
    publishers: 'publishers',
    publishersShares: 'publishers-shares',
    publishersWriters: 'publishers-writers',
    recordings: 'recordings',
    review: 'review',
    submission: 'submission',
})
// songwriter routes
export const SONGWRITER_ROUTE = 'songwriter'
const SONGWRITER_ROUTE_WITH_ID = `${SONGWRITER_ROUTE}/${PARAM.songwriterId}`
const SONGWRITER_SUB_ROUTES = Object.freeze({
    link: 'link',
    cowriters: {
        root: 'cowriters',
        search: 'search',
        view: `${PARAM.cowriterIpId}`,
    },
    catalog: {
        viewWork: `${VIEW_WORK_ROUTE}/${PARAM.workId}/${VIEW_ROUTE}`,
        requestUpdateShares: `${VIEW_WORK_ROUTE}/${PARAM.workId}/request-update-shares`,
        root: CATALOG_ROUTE,
    },
    myWriters: 'my-writers',
    searchedWork: `search/work/${PARAM.workId}/${VIEW_ROUTE}`,
    matchingTool: 'matching-tool',
    matchHistory: {
        recording: `${MATCH_HISTORY_ROUTE}/${PARAM.submissionId}/${RECORDING_ROUTE}/${PARAM.recordingGroupCategory}`,
        submission: `${MATCH_HISTORY_ROUTE}/${PARAM.submissionId}`,
        root: 'match-history',
    },
})

export {
    LOGIN_ROUTE,
    RELEASE_NOTES_ROUTE,
    UPCOMING_NOTES_ROUTE,
    INACTIVE_ROUTE,
    SIGN_UP_ROUTE,
    SIGN_UP_COMPLETE_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    CREATE_PASSWORD_ROUTE_WITH_ACT_CODE,
    NEW_USER_ROUTE,
    SEARCH_ROUTE,
    SEARCH_ROUTE_WITH_TAB_NAME,
    PUBLIC_VIEW_WORK_ROUTE_WITH_WORK_ID,
    CONTACT_US_ROUTE,
    ACCESS_DENIED_ROUTE,
    UI_ROUTE,
    RECORDING_DETAILS_ROUTE_WITH_RECORDING_ID,
    PROFILE_ROUTE,
    CHANGE_PASSWORD_ROUTE,
    RIGHTSHOLDER_ROUTE_WITH_ID,
    CREATE_WORK_ROUTE,
    MANUAL_ROUTE,
    WIZARD_ROUTE,
    STEP_ROUTES,
    FORM_ROUTE,
    BULK_ROUTES,
    RIGHTSHOLDER_SUB_ROUTES,
    EDIT_WORK_ROUTE,
    EDIT_ROUTE,
    EDIT_DRAFT_ROUTE,
    REGISTRATION_MEMBER_ROUTE,
    FORM_SEGMENT,
    QUESTIONNAIRE_ROUTE,
    ENROLL_MFA_ROUTE,
    SONGWRITER_ROUTE_WITH_ID,
    SONGWRITER_SUB_ROUTES,
    REGISTRATION_SONGWRITER_ROUTE,
    NOTIFICATION_PREFERENCES_ROUTE,
    BENEFITS_ROUTE,
}
